import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ControleSeapService } from '../controle-seap.service';

@Component({
  selector: 'app-add-matricula',
  templateUrl: './add-matricula.component.html',
  styleUrls: ['./add-matricula.component.scss']
})
export class AddMatriculaComponent implements OnInit {
  id;
  name;
  curso = -1;
  penitenciaria;
  startDate;
  endDate;
  cursos = [];
  cursosById = {};
  constructor(private toastr: ToastrService, private server: ControleSeapService, private router: Router, private route: ActivatedRoute) { 
    const x = new Date();
    this.startDate = this.getDate(x);
    
    if(this.route.snapshot.params['id']) {
      this.id = this.route.snapshot.params['id'];
      server.getMatriculaById(this.id).then(res => {
        if (res && res.val()) {
          this.name = res.val().name;
          this.curso = res.val().curso;
          this.startDate = res.val().startDate;
          this.endDate = res.val().endDate;
          this.penitenciaria = res.val().penitenciaria;
        } else{
          this.id = null;
        }
      }).catch(() =>
        this.id = null
      );
    }

    server.getCursosStatic().then(res => {
      this.cursos = [];
      this.cursosById = {};

      res.forEach(c => {
        const d = c.val();
        d.id = c.key;
        this.cursos.push(d);
        this.cursosById[d.id] = d;
      });
    })
  }

  ngOnInit() {
  }

  getDate(x){
    return `${x.getFullYear()}-${this.two(x.getMonth()+1)}-${this.two(x.getDate())}`;
  }

  two(s) {
    if (s.toString().length === 1 ) {
      return "0" + s;
    }
    return s;
  }

  updateEndDate() {
    console.log(this.startDate);
    if (!this.cursosById[this.curso]) return; 
    
    const x = new Date(this.startDate.replace('-', '/').replace('-', '/'));
    const ts = x.setDate(x.getDate() + this.cursosById[this.curso].time + 10);
    const newDate = new Date(ts);

    let totalSundays = 0;
    for (var i = new Date(this.startDate.replace('-', '/').replace('-', '/')); i <= newDate; ){
      if (i.getDay() == 0){
          totalSundays++;
      }
      i.setTime(i.getTime() + 1000*60*60*24);
    }
    newDate.setTime(newDate.getTime() + 1000*60*60*24*totalSundays)
    if(newDate.getDay() == 0)
      newDate.setTime(newDate.getTime() + 1000*60*60*24)

    this.endDate = this.getDate(newDate)
  }

  send() {
    if (!this.name || !this.name.toString().length){
      this.toastr.error('Você deve informar o nome do aluno!');
      return;
    }

    if (!this.penitenciaria || !this.penitenciaria.toString().length){
      this.toastr.error('Você deve informar o nome da penitenciária!');
      return;
    }
    
    if (!this.curso || !this.curso.toString().length || this.curso === -1){
      this.toastr.error('Você deve informar o curso!');
      return;
    }

    if (!this.startDate || !this.startDate.toString().length){
      this.toastr.error('Você deve informar a data de início do curso!');
      return;
    }

    if (!this.endDate || !this.endDate.toString().length){
      this.toastr.error('Você deve informar a data de término do curso!');
      return;
    }

    this.server.insertMatricula({name: this.name, penitenciaria: this.penitenciaria, curso: this.curso, cursoName: this.cursosById[this.curso].name, startDate: this.startDate, endDate: this.endDate}, this.id).then(res => {

      if (res) {
        this.toastr.success('Matrícula salva!');
        this.router.navigate(['/controle-seap'])
        return;
      } else {
        this.toastr.error('Ocorreu um erro, tente novamente!')
      }
    })
  }

}
